module.exports = __webpack_public_path__ + "assets/img/img-4.188b3492.png";